import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import leaf from "../../Assets/Projects/YOLO.png";
import emotion from "../../Assets/Projects/emotion.jpeg";
import editor from "../../Assets/Projects/IRS.png";
import eeg from "../../Assets/Projects/eeg.gif";
import suicide from "../../Assets/Projects/MU.png";
import algo from "../../Assets/Projects/algo.png";
import plant from "../../Assets/Projects/plant.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Past <strong className="purple">Work </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="PPE Detection"
              description="Implemented a safety system to detect PPE (Personal Protective Equipment) compliance and fires in construction sites and industries. Employed Convolutional Neural Networks (YOLOv3) for object detection in videos. Obtained a mean average precision of object detection of 77.58%."
              link="https://github.com/rishidhaka/PPE_Detection_YOLOv3"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Predicting Foundation Gifting Capacity"
              description="Implemented fuzzy data matching, clustering, NLP to extract IRS 990 data from AWS S3 servers. Raised the university's fundraising revenue by $1.4M per year by implementing predictive models to gauge the giving capacity of foundations."
              link="https://github.com/rishidhaka/IRS-990-Analysis"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Manchester United Performance Analysis Dashboard"
              description="Created a dashboard on Tableau presenting Manchester United's performances over 13 years compared to other clubs. Analysed patterns and the reasons for Manchester United's sustained success over this period of time."
              link="https://github.com/rishidhaka/Manchester-United-Performance-Analysis"
            />
          </Col>
{/*
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link="https://github.com/rishidhaka/Face_And_Emotion_Detection"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eeg}
              isBlog={false}
              title="Emotion Predcition from EEG Signals"
              description="Using EEG signals from 'AMIGOS' Dataset to extract features and train a classifier that helps in detection of human emotions from Brain Signals."
              link="https://gist.github.com/rishidhaka/dc94177bc4954752051798f88fbce1df"
            />
</Col>*/}
        </Row>
        {/*
        <h1 className="project-heading">
          My Recent <strong className="purple">Blog </strong> Posts
        </h1>
        <p style={{ color: "white" }}>Do give a read to some of my blogs</p>
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={algo}
              link=""
              title="Cracking Interview"
              site="gitbook.com"
            />
          </Col>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={plant}
              link="https://medium.com/jovianml/plant-ai-c8fc95ed90e6"
              title="Plant AI"
              site="medium.com"
            />
          </Col>
        </Row>*/}
      </Container>
    </Container>
  );
}

export default Projects;
